export enum PresignedUrlRequestMethod {
  PUT = "PUT",
  GET = "GET",
}

export interface PresignedUrlRequest {
  keyName: string;
  method: PresignedUrlRequestMethod;
}

export interface PresignedUrlResponse {
  presignedUrl?: string;
  keyExists?: boolean;
  errorMessage?: string;
}

export interface ListSnapshotObjectsRequest {
  prefix: string;
}

export interface ListSnapshotObjectsResponse {
  s3objects?: S3ResourceSelectorObject[];
  errorMessage?: string;
}

interface S3ResourceSelectorObject {
  key: string;
  lastModified: string;
  size: number;
  isFolder: boolean;
}
